function User1() {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="user-1-icon"
    >
      <path
        d="M20 0C8.952 0 0 8.952 0 20s8.952 20 20 20 20-8.952 20-20S31.048 0 20 0zm10.323 34c-2.896 2.137-6.46 3.42-10.323 3.42-3.863 0-7.427-1.283-10.323-3.42v-1.097a5.166 5.166 0 015.162-5.161c.895 0 2.217.92 5.161.92 2.952 0 4.258-.92 5.161-.92a5.166 5.166 0 015.162 5.161V34zm2.467-2.218c-.548-3.742-3.734-6.62-7.629-6.62-1.653 0-2.451.919-5.161.919-2.71 0-3.5-.92-5.161-.92-3.896 0-7.08 2.88-7.63 6.621C4.348 28.677 2.582 24.548 2.582 20 2.58 10.395 10.395 2.58 20 2.58S37.42 10.396 37.42 20c0 4.548-1.767 8.677-4.63 11.782zM20 9.032a7.097 7.097 0 100 14.194 7.097 7.097 0 000-14.194zm0 11.613a4.519 4.519 0 01-4.516-4.516A4.519 4.519 0 0120 11.613a4.519 4.519 0 014.516 4.516A4.519 4.519 0 0120 20.645z"
        fill="#2c2c2c"
      />
    </svg>
  );
}

export default User1;
